export const departmentQueryKeys = {
  all: ["departments"],
};
